import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Gtp } from 'src/app/shared/gtp';

import { MiCuentaService } from 'src/app/services/admin/mi-cuenta/mi-cuenta.service';

@Component({
  selector: 'app-cuenta',
  templateUrl: './cuenta.component.html',
  styleUrls: ['./cuenta.component.scss']
})
export class CuentaComponent implements OnInit {
  public loading: boolean = false;
  public alertFail: boolean = false;
  public alertSuccess: boolean = false;
  public editar: boolean = true;
  //public guardar: boolean = true;
  public cancelar: boolean = true;
  public alertMsg: string = '';

  public alertFailCon: boolean = false;
  public alertSuccessCon: boolean = false;

  showPassword: boolean = false;
  user = {
    usuario: 'Prueba',
    current:'',
    password: ''
  }
  cuenta = {
    cod_cliente:'',
    nombre: '',
    apellido: '',
    nro_documento:null,
    direccion:'',
    telefono_p:null,
    telefono_c:null,
    direccion_l:'',
    telefono_l:null,
    fax:null,
    email:''
  }
  plan_cliente_id =  null
  public verCuenta: boolean = false;
  public verUser: boolean = false;

  public verPlan: boolean = false;
  // La propiedad selectedTabIndex fue removida porque no es innecesaria para este diseño simplificado

  constructor(
    private router: Router,
    private gtp: Gtp,
    private callapi: MiCuentaService,

  ) { }

  ngOnInit(): void {
    this.callapi.getCliente().subscribe( res => {
      //console.log(res['cliente'])
      this.cuenta.cod_cliente=res['cliente'].cod_cliente
      this.cuenta.nombre=res['cliente'].nom_cliente
      this.cuenta.apellido=res['cliente'].ape_cliente
      this.cuenta.direccion=res['cliente'].dir_cliente_part
      this.cuenta.telefono_p=res['cliente'].tel_cliente_part
      this.cuenta.telefono_c=res['cliente'].cel_cliente_part
      this.cuenta.direccion_l=res['cliente'].dir_cliente_lab
      this.cuenta.telefono_l=res['cliente'].tel_cliente_lab
      this.cuenta.fax=res['cliente'].fax_cliente_lab
      this.cuenta.email=res['cliente'].email_cliente
      this.cuenta.nro_documento=res['cliente'].nro_documento

      if (res['cliente'].cod_cliente === 2) {
        this.verPlan = true;
      }
    });

    this.callapi.getUsuario().subscribe( res => {
      //console.log(res['usuario'])
      this.user.usuario=res['usuario'].usuario
    });
  }


  closeform(){
    this.gtp.setAdminSidebar(true);
  }

  doCancelar(){
    this.router.navigate(['/inicio/flota'])
    this.cuenta.cod_cliente = ''
    this.cuenta.nombre = ''
    this.cuenta.apellido = ''
    this.cuenta.nro_documento = ''
    this.cuenta.direccion = ''
    this.cuenta.telefono_p = ''
    this.cuenta.telefono_c = ''
    this.cuenta.direccion_l = ''
    this.cuenta.telefono_l = ''
    this.cuenta.fax = ''
    this.cuenta.fax = ''
    this.cuenta.email = ''
    this.user.password = ''

  }

  doCancelarCon(){
    this.doCancelar()
  }

  doEditar(){
    this.loading = true;

    this.callapi.getClienteUpdate(this.cuenta).subscribe(res => {
      if (res) {
        //console.log(res)
        this.alertMsg = 'CUENTA ACTUALIZADA';
        this.alertSuccess = true;
      }else{
        //console.log(res)
        this.alertMsg = 'OCURRIO UN ERROR EN EL PROCESO';
        this.alertFail = true;
      }
    },(error)=>{
        //console.log(error);
        this.alertMsg = error;
        this.alertFail = true;
        this.loading = false;

      });

    setTimeout(() => {
      //this.doCancelar()
      this.alertSuccess = false;
      this.alertFail = false;
      this.loading = false;
    }, 2000)
  }

  doEditarCon(){
    this.loading = true;

    this.callapi.getUsuarioPassUpdate(this.user).subscribe(res => {
      if (res['success']===true) {
        console.log(res)
        this.alertSuccess = true;
        this.alertMsg = res['message'];
      }
    },(error)=>{
        console.log(error);
        this.alertFail = true;
        this.alertMsg = error;
        //return;
    });

    setTimeout(() => {
      //this.doCancelar()
      this.alertSuccess = false;
      this.alertFail = false;
      this.loading = false;
    }, 2000)
  }

  showPass() {
    this.showPassword = !this.showPassword;

  }


  onPlanChange(event: any): void {
    console.log('Nuevo plan seleccionado:', this.plan_cliente_id);
    //ACTUALIZAMOS DIRECTAMENTE CON EL CHANGE



  }
}
